import * as THREE from 'three';
import * as marietta from '../../..';
import { ThreeView } from '../View3dWebCad';

export class Picker {
  _itemId: any;

  // このインスタンスのメインコンテナ
  _el: any;

  // ターゲットとなる Three.js オブジェクト
  target: THREE.Object3D;

  // 変更可能なアイテムのリスト
  altItems: any;

  _dispatcher: any;

  _visible: boolean;

  _origin: THREE.Vector3;

  private handlers;

  constructor(id: any, container: any, obj: any, origin: THREE.Vector3, private rotate: boolean, private sizeIcon, private duplicateIcon: boolean, private textIcon, dispatcher: any) {
    this._dispatcher = dispatcher;
    this._visible = true;
    const dir = marietta.view3d.webcad.View3dGlobal.shared.itemDir;
    this.drawPick('pick', id, -100, -100, container);
    this.target = obj;
    this._origin = origin;
    this.altItems = this.target.userData.attribute ? this.target.userData.attribute.alternative : null;
  }

  public getTargetObject() {
    return this.target;
  }

  public getTargetPoint() {
    return this._origin;
  }

  public setTargetObject(object: THREE.Object3D) {
    this.target = object;
  }
  public getAltItems() {
    return this.altItems;
  }

  public visible() {
    return this._visible;
  }

  public getItemId() {
    return this._itemId;
  }

  private mouseOver(msg: string) {
    this._dispatcher.dispatchEvent(new marietta.view3d.base.events.Event(marietta.view3d.webcad.webcadDefines.WebCadEventNames.mouseOver, msg));
  }

  private mouseOut(msg: string) {
    this._dispatcher.dispatchEvent(new marietta.view3d.base.events.Event(marietta.view3d.webcad.webcadDefines.WebCadEventNames.mouseOut, msg));
  }

  private mouseDown(msg: string) {
    this._dispatcher.dispatchEvent(new marietta.view3d.base.events.Event(marietta.view3d.webcad.webcadDefines.WebCadEventNames.mouseDown, msg));
  }

  // イベントの付与
  private addEventPointer(name: string, elemet) {
      const addHandler = (name_: string, element, func)  => {
          element.addEventListener(name_, func);
          return () => element.removeEventListener(name_, func);
      }

      this.handlers = [
          addHandler('pointerover', elemet, e => this.mouseOver(name)),
          addHandler('pointerout', elemet, e => this.mouseOut(name))
      ];
  }

  // movePickerCanvas を作成
  private movePicker() {
    const div = document.createElement('div');
    div.style.width = '40px';
    div.style.height = '40px';
    div.style.position = 'relative';
    div.classList.add('wtCamSet');
    div.id = `${this._el.id}_moveBtn`;
    this._el.appendChild(div);
    // マウスイベント
    this.addEventPointer('movePicker', div);
    const isTablet = marietta.WebCADGlobal.userAgentManager.isTablet;
    if (!isTablet) div.addEventListener('mousedown', e => this.mouseDown('downPicker'));

    div.innerHTML = '<span class="icon icon-move_picker_w"></span>';
  }

  // spinPickerCanvas を作成
  private spinPicker() {
    const div = document.createElement('div');
    div.style.width = '40px';
    div.style.height = '40px';
    div.style.position = 'relative';
    div.classList.add('wtCamSet');
    div.id = `${this._el.id}_spinBtn`;
    this._el.appendChild(div);
    // マウスイベント    
    this.addEventPointer('spinPicker', div);
    const isTablet = marietta.WebCADGlobal.userAgentManager.isTablet;
    if (!isTablet) div.addEventListener('mousedown', e => this.mouseDown('downPicker'));

    div.innerHTML = '<span class="icon icon-spin_picker_w"></span>';
  }

  // sizePickerCanvas を作成
  private sizepicker() {
    const div = document.createElement('div');
    div.style.width = '40px';
    div.style.height = '40px';
    div.style.position = 'relative';
    div.classList.add('wtCamSet');
    div.id = `${this._el.id}_sizeBtn`;
    this._el.appendChild(div);
    // マウスイベント 
    this.addEventPointer('sizepicker', div);

    div.addEventListener('click', (e: any) => {
      e.preventDefault();
      e.stopPropagation();
      this._dispatcher.dispatchEvent(new marietta.view3d.base.events.Event(marietta.view3d.webcad.webcadDefines.WebCadEventNames.sizePickerClicked, this.target));
    });
    div.innerHTML = '<span class="icon icon-size_picker"></span>';
  }

    // sizePickerCanvas を作成
    private duplicatePicker() {
      const div = document.createElement('div');
      div.style.width = '40px';
      div.style.height = '40px';
      div.style.position = 'relative';
      div.classList.add('wtCamSet');
      div.id = `${this._el.id}_sizeBtn`;
      this._el.appendChild(div);
      // マウスイベント
      this.addEventPointer('duplicatePicker', div);

      div.addEventListener('click', (e: any) => {
          e.preventDefault();
          e.stopPropagation();
          this._dispatcher.dispatchEvent(new marietta.view3d.base.events.Event(marietta.view3d.webcad.webcadDefines.WebCadEventNames.duplicatePickerClicked, this.target));
      });
      div.innerHTML = '<span class="icon icon-copy_picker"></span>';
    }

    // textPickerCanvas を作成
    private textPicker() {
      const div = document.createElement('div');
      div.style.width = '40px';
      div.style.height = '40px';
      div.style.position = 'relative';
      div.classList.add('wtCamSet');
      div.id = `${this._el.id}_sizeBtn`;
      this._el.appendChild(div);

      const pickerName = 'textPicker';
      // マウスイベント
      this.addEventPointer(pickerName, div);

      div.addEventListener('click', (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        this._dispatcher.dispatchEvent(new marietta.view3d.base.events.Event(marietta.view3d.webcad.webcadDefines.WebCadEventNames.textPickerClicked, this.target));
      });
      div.innerHTML = '<span class="icon icon-comment_picker"></span>';
    }

  // deletePickerCanvas を作成
  private deletepicker() {
    const div = document.createElement('div');
    div.style.width = '40px';
    div.style.height = '40px';
    div.style.position = 'relative';
    div.classList.add('wtCamSet');
    div.id = `${this._el.id}_deleteBtn`;
    this._el.appendChild(div);
    // マウスイベント
    this.addEventPointer('deletepicker', div);

    div.addEventListener('click', (e: any) => {
      e.preventDefault();
      e.stopPropagation();
      this._dispatcher.dispatchEvent(new marietta.view3d.base.events.Event(marietta.view3d.webcad.webcadDefines.WebCadEventNames.deletePickerClicked, this.target));
    });
    div.innerHTML = '<span class="icon icon-garbage_picker"></span>';
  }

  private blank() {
    const div = document.createElement('div');
    div.style.width = '13px';
    div.style.height = '40px';
    div.style.position = 'relative';
    div.classList.add('wtCamSet');
    div.id = `space`;
    this._el.appendChild(div);
  }


  public drawPick(prefix: any, id: any, left: number, top: number, container: any) {
    this._itemId = id;

    this._el = document.createElement('div');
    this._el.id = prefix + id;
    this._el.style.display = 'none';
    this._el.style.flexWrap = 'nowrap';
    // this._el.style.flexDirection = 'column';

    this._el.style.alignItems = 'center';
    this._el.style.position = 'absolute';
    this._el.style.padding = 0;
    this._el.style.margin = 0;
    this._el.style.zindex = '100';
    this._el.style.left = `${left}px`;
    this._el.style.top = `${top}px`;
    container.appendChild(this._el);

    this.movePicker();
    if (this.rotate) {
      this.spinPicker();
    }
    if (this.sizeIcon) {
        this.sizepicker();
    }
    if (this.duplicateIcon) {
        this.duplicatePicker();
    }
    if (this.textIcon) {
        this.textPicker();
    }
    this.blank();
    this.deletepicker();

  }

  // update
  public update(v2: any) {
    if (this._visible == false) return;
    // 座標をセット
    this._el.style.left = `${v2.x}px`;
    this._el.style.top = `${v2.y}px`;
    // 2D の位置が表示範囲外の時は、表示フラグ（_visible）は保持したまま非表示にする。
    this._el.style.display = (v2.x < 0 || v2.y < 0) ? 'none' : 'flex';
  }

  public hide() {
    this.update({ x: -100, y: -100 });
  }

  // removed
  public removed() {
    // 子要素を全て削除
    while (this._el.firstChild) this._el.removeChild(this._el.firstChild);
    // 自分を削除
    this._el.parentNode.removeChild(this._el);
  }
}
